{
  "slug": "how-is-iq-measured",
  "title": "Comment le QI est-il mesuré?",
  "description": "Comprendre les tests de QI standardisés, les normes basées sur l'âge, les sous-tests, les percentiles et pourquoi chaque résultat a une marge d'erreur.",
  "summary": "Le QI est mesuré avec des tâches cognitives standardisées, les performances brutes sont comparées aux normes basées sur l'âge et converties en un score, généralement centré sur. 100.",
  "sections": [
    {
      "heading": "Des tâches à un score standardisé",
      "paragraphs": [
        "Une évaluation comprend plusieurs sous-tests, par exemple l’identification de modèles, la manipulation de l’information en mémoire, la résolution de problèmes verbaux ou le travail précis dans des délais donnés. Les totaux bruts n’ont pas beaucoup de sens à eux seuls, donc les éditeurs les comparent à un échantillon de référence plus important.",
        "Les résultats sont comparés à ceux de personnes du même groupe d’âge, puis les résultats des sous-tests peuvent être combinés pour obtenir des scores d’indice plus larges et une estimation globale."
      ]
    },
    {
      "heading": "Normes, centiles et écart",
      "paragraphs": [
        "De nombreux tests actuels utilisent une moyenne de 100 et un écart type de. 15. Un centile exprime la position: 100 est près de la 5010e centile, tandis que 120 est autour de la 911er centile dans une distribution normale.",
        "Différents instruments utilisent des tâches et des normes différentes, de sorte que deux tests valides ne produisent pas toujours des scores identiques."
      ]
    },
    {
      "heading": "Pourquoi l’interprétation est importante",
      "paragraphs": [
        "Un examinateur qualifié tient également compte des modèles de sous-tests, de la langue, du contexte culturel, des conditions d’examen et de l’objectif de l’évaluation, et il peut également prendre en compte les résultats de tests de mémoire et de compréhension.",
        "Une bonne mesure dépend des instructions standard, des normes appropriées, de la sécurité des tests, de la fiabilité et de la validité, et un chiffre sans ce contexte peut être trompeur."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Pourquoi certaines tâches de QI sont-elles chronométrées?",
      "answer": "Certains sous-tests mesurent l’efficacité du traitement, mais de nombreuses tâches de raisonnement ne sont pas chronométrées ou ont des limites généreuses."
    },
    {
      "question": "Les différents tests de QI peuvent-ils donner des résultats différents?",
      "answer": "Oui, le contenu, les normes, les erreurs de mesure, la santé et les conditions d'essai peuvent entraîner des différences raisonnables."
    }
  ],
  "related": ["what-is-iq", "what-is-the-average-iq", "iq-score-ranges-explained"]
}
